export const LinearProgressLoader = ({ active }: { active: boolean }) => {
  return (
    <div className="h-[5px] w-full min-w-0">
      <div className={`relative h-[5px] w-full overflow-hidden rounded-[5px] ${active ? 'bg-nav-active-bg' : ''}`}>
        {active ? (
          <div className="absolute left-0 top-[2px] h-1.5 w-1/3 min-w-[80px] max-w-full animate-linearProgressLoading rounded-[5px] bg-gradient-to-r from-brand to-accent" />
        ) : null}
      </div>
    </div>
  );
};
